module.exports = __webpack_public_path__ + "ae72c0046960851a1402166312f41fb3.woff2";